import produce from 'immer'
import {
  CONTAINER_TYPES_LOAD,
  CONTAINER_TYPES_LOAD_SUCCESS,
  CONTAINER_TYPES_LOAD_FAIL
} from './actions'

const initialState: {
  loading: boolean
  error: any
  containerTypes: string[]
} = {
  loading: false,
  error: null,
  containerTypes: []
}

export const reducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case CONTAINER_TYPES_LOAD: {
        draft.loading = true
        draft.error = null
        draft.containerTypes = []
        return
      }
      case CONTAINER_TYPES_LOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.containerTypes.push(...action.containerTypes)
        return
      }
      case CONTAINER_TYPES_LOAD_FAIL: {
        draft.loading = false
        draft.error = action.error
        return
      }
      default:
        return
    }
  })
